import React, { Component } from "react";
import "./DiscretesAndTrends.scss";
import Chiclet from "../Chiclet";
import { observer } from "mobx-react";
import TrendStore from "./TrendStore";
import TrendChart from "./TrendChart";
import Loader from "../Loader";
import { chartColors } from "./TrendChart";
import Icon from "../Icon";
import config from "../../config";

class DiscretesAndTrends extends Component {
  constructor(props) {
    super(props);
    this.store = new TrendStore({ fetchTrends: props.fetchTrends });
    this.state = {};
  }

  static getDerivedStateFromProps(props) {
    return {
      discretes: DiscretesAndTrends.addColors(props.discretes),
      moreTrends: props.moreTrends || [],
      discreteGroups: props.discreteGroups,
    };
  }

  static addColors(discretes) {
    return discretes.map((d, i) => ({
      ...d,
      color: chartColors[i % chartColors.length],
    }));
  }

  render() {
    return (
      <div className="discretes-and-trends">
        <div className="chiclets">
          {this.state.discretes &&
            this.state.discretes.map((discrete) => (
              <Chiclet
                chart={discrete}
                toggleChart={() =>
                  !this.props.disableTrends &&
                  this.store.toggleTrendChart(discrete)
                }
                key={this.store.discreteKey(discrete)}
                active={this.store.isDiscreteActive(discrete)}
                showTrends={config.pm.showTrends}
              />
            ))}
        </div>
        <div className="trend-charts">
          {[
            ...this.store.getActiveTrendCharts(this.state.discretes),
            ...this.state.moreTrends,
          ].map((chart) => (
            <div
              className={`chart ${chart.title
                .toLowerCase()
                .replace(/[^\w]/g, "-")}`}
              key={chart.title}
            >
              <Icon
                symbol="x"
                onClick={() => this.store.toggleTrendChart(chart)}
              />
              <div className="chart-title">{chart.title}</div>
              {this.store.isTrendLoading(chart) ? (
                <Loader size="trend-chart" />
              ) : (
                <TrendChart trend={chart.trend} color={chart.color} />
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default observer(DiscretesAndTrends);
